import { render, staticRenderFns } from "./ExpansionPanel.vue?vue&type=template&id=5e09a0f0&scoped=true"
import script from "./ExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./ExpansionPanel.vue?vue&type=script&lang=ts"
import style0 from "./ExpansionPanel.vue?vue&type=style&index=0&id=5e09a0f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e09a0f0",
  null
  
)

export default component.exports